// extracted by mini-css-extract-plugin
export default {"icon":"Tooltip_icon__llCoz","recordHistoryHelpIcon":"Tooltip_recordHistoryHelpIcon__onz13"};